export const Filter = {
  SerialNumber: "serialNumber" as const,
  OwnerId: "ownerId" as const,
  OwnerName: "ownerName" as const,
  Date: "date" as const,
  EndDate: "endDate" as const,
  CustomerId: "customerId" as const,
  CustomerName: "customerName" as const,
  Amount: "amount" as const,
  States: "states" as const,
}

export const Details = {
  CustomerName: "customerName" as const,
  CustomerOrgNr: "customerOrgNr" as const,
  ReferencePerson: "referencePerson" as const,
  ContactPerson: "contactPerson" as const,
  AmountIncludingVat: "amountIncludingVat" as const,
  AmountExcludingVat: "amountExcludingVat" as const,
  Vat: "vat" as const,
  Currency: "currency" as const,
  QuotationDate: "quotationDate" as const,
  ExpireDate: "expireDate" as const,
  PaymentDate: "paymentDate" as const,
  Bg: "bg" as const,
  Ocr: "ocr" as const,
  Dimensions: "dimensions" as const,
}

